<template>
  <BaseDialog
    :title="$t('survey.editMembers')"
    :is-open="isOpen"
    type="responsive"
    :align-dismiss-button-right="true"
    @close="closeDialog"
  >
    <SurveyMembersForm
      v-model:feedback-sender-ids="form.feedbackSenderIds"
      :members-error="errors.get('feedbackSenderIds')"
    />
    <template #confirm>
      <BaseTextButton color="filled" size="M" :disabled="isSaving" @click="saveEdits">
        {{ $t('common.save') }}
      </BaseTextButton>
    </template>
    <template #dismiss>
      <BaseTextButton color="text" size="M" :disabled="isSaving" @click="closeDialog">
        {{ $t('common.cancel') }}
      </BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import { computed, toRef } from 'vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import SurveyMembersForm from '@/modules/start-survey/components/SurveyMembersForm.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import type { CoachFeedbackGoal } from '../composables/use-coach-feedback-goal'
  import { useEditCoachFeedbackGoalMembers } from '../composables/use-edit-coach-feedback-goal-members'

  interface Props {
    isOpen: boolean
    feedbackGoal: CoachFeedbackGoal
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'close-dialog'): void
    (e: 'goal-updated'): void
  }>()

  const closeDialog = () => emit('close-dialog')

  const { form, errors, isSaving, saveMembers } = useEditCoachFeedbackGoalMembers(
    computed(() => props.feedbackGoal),
    toRef(props, 'isOpen'),
    () => {
      emit('goal-updated')
      emit('close-dialog')
    },
  )

  const saveEdits = async () => {
    await saveMembers()
  }
</script>
